import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TyreRequestState } from 'state/types/tyreRequest';
import { AtLeastOneRequired } from 'types/generic';

const initialState: TyreRequestState = {};

type PreCheckState = Pick<TyreRequestState, 'hasBeenPayed' | 'hasBeenRepaired'>;

export const tyreRequestSlice = createSlice({
    name: 'tyreRequest',
    initialState,
    reducers: {
        setPreCheckData(
            state,
            action: PayloadAction<AtLeastOneRequired<PreCheckState>>
        ) {
            Object.assign(state, action.payload);
        },
        resetTyreRequest() {
            return initialState;
        }
    }
});

export const { setPreCheckData, resetTyreRequest } = tyreRequestSlice.actions;
